import React, { useState } from 'react'
import { EyeIcon } from '@heroicons/react/24/outline'
import RightSlideOver from './RightSlideOver'

interface DescriptionWrapperProps {
  description?: string
  maxLen: number
  title: string
}

const DescriptionWrapper = ({ description, maxLen, title }: DescriptionWrapperProps) => {
  const [open, setOpen] = useState(false)
  return (
    (description?.length ?? 0) > maxLen ?
      <span>
                <RightSlideOver title={title} content={description!} isOpen={open} setOpen={setOpen}
                                iconOptional={EyeIcon}/>
        {`${description!.substring(0, maxLen)}...`}&nbsp;<EyeIcon
        onClick={() => setOpen(true)}
        className="cursor-pointer align-middle inline h-4 w-4 text-perfect-shine-800" aria-hidden="true"/>
            </span>
      : description
  )
}

export default DescriptionWrapper
